import { render, staticRenderFns } from "./AccommodationConfigurator.vue?vue&type=template&id=b689d12e&scoped=true&"
import script from "./AccommodationConfigurator.vue?vue&type=script&lang=js&"
export * from "./AccommodationConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b689d12e",
  null
  
)

export default component.exports